import { render } from "./AddRole.vue?vue&type=template&id=51f1ee1c&ts=true"
import script from "./AddRole.vue?vue&type=script&lang=ts"
export * from "./AddRole.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__